import styled from 'styled-components';

import { ResizableTextarea } from '@r1-frontend/ui-react/experimental/forms';

export const Block = styled.div`
    display: block;
    width: 100%;
    
    ${ResizableTextarea} {
        width: 100%;
    }
`;

const DefaultWrapper = styled.div`
    display: flex;
    gap: 2px;
`;

export const DaysWrapper = styled(DefaultWrapper)`
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
`;

export const HoursWrapper = styled(DaysWrapper)`
    flex-wrap: wrap;
    padding-bottom: 0;
`;
